import Icon from '../Icon';
import type { LucideIconData, LucideIconNode, LucideProps } from '../types';

export const __iconData: LucideIconData = {
  name: 'mosque',
  size: 24,
  node: [
    ['path', { d: 'M12.268 2a2 2 0 003.465 2', key: '3in8xp' }],
    ['path', { d: 'M14 5 L14 8', key: '1fhhfb' }],
    ['path', { d: 'M16 22v-3a2 2 0 00-4 0v3', key: '1p6nbd' }],
    [
      'path',
      {
        d: 'M21 13c-.662-1.497-1.666-2.753-2.9-3.63C16.825 8.47 15.422 8 14 8s-2.826.47-4.1 1.37C8.668 10.248 7.663 11.504 7 13z',
        key: 'ck3r5y',
      },
    ],
    ['path', { d: 'M3 9h4', key: 'rnfnj5' }],
    [
      'path',
      { d: 'M7 22V6a5 5 0 00-2-4 5 5 0 00-2 4v14a2 2 0 002 2h14a2 2 0 002-2v-7', key: '28kgc3' },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Mosque
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuMjY4IDJhMiAyIDAgMDAzLjQ2NSAyIiAvPgogIDxwYXRoIGQ9Ik0xNCA1IEwxNCA4IiAvPgogIDxwYXRoIGQ9Ik0xNiAyMnYtM2EyIDIgMCAwMC00IDB2MyIgLz4KICA8cGF0aCBkPSJNMjEgMTNjLS42NjItMS40OTctMS42NjYtMi43NTMtMi45LTMuNjNDMTYuODI1IDguNDcgMTUuNDIyIDggMTQgOHMtMi44MjYuNDctNC4xIDEuMzdDOC42NjggMTAuMjQ4IDcuNjYzIDExLjUwNCA3IDEzeiIgLz4KICA8cGF0aCBkPSJNMyA5aDQiIC8+CiAgPHBhdGggZD0iTTcgMjJWNmE1IDUgMCAwMC0yLTQgNSA1IDAgMDAtMiA0djE0YTIgMiAwIDAwMiAyaDE0YTIgMiAwIDAwMi0ydi03IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mosque
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mosque = (props: LucideProps) => <Icon {...props} icon={__iconData} />;

export default Mosque;
